var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 578.52 20.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6141e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,5.17v-2.13h2.24v2.13H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.98,1.66V0h4.05v1.66h-4.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.76,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.28,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.26,1.66V0h4.05v1.66h-4.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.04,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.55,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m140.54,1.66V0h4.05v1.66h-4.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m152.31,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m195.83,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.82,1.66V0h4.05v1.66h-4.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m217.59,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m261.11,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m271.09,1.66V0h4.05v1.66h-4.05Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m282.87,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m326.39,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m336.37,1.66V0h4.05v1.66h-4.05Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m348.15,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m391.67,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m401.65,1.66V0h4.05v1.66h-4.05Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m413.42,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m456.94,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m466.93,1.66V0h4.05v1.66h-4.05Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m478.7,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m522.22,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m532.2,1.66V0h4.05v1.66h-4.05Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m543.98,5.17v-2.13h2.24v2.13h-2.24Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.41,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.62,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.17,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.68,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.9,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.44,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.96,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m173.18,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.72,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m229.24,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m238.46,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m251,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m294.52,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.73,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m316.28,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m359.79,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m369.01,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m381.55,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m425.07,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m434.29,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m446.83,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m490.35,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m499.57,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m512.11,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m555.63,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m564.84,20.86v-1.66h4.05v1.66h-4.05Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m577.39,17.87l-.43-2.13v-2.35h1.57v2.35l-.43,2.13h-.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectSeperator);
export default __webpack_public_path__ + "static/media/object-seperator.f6ae03097c81776d2588a03465b1cb8a.svg";
export { ForwardRef as ReactComponent };